// Frutiger Aero Pastel Theme - Branco e Azul Pastel
export const theme = {
  // Cores Principais - Azuis pastéis Frutiger Aero
  primaryBlue: '#3B9ED4',
  primaryBlueDark: '#2178AB',
  primaryBlueLight: '#6BBDDF',
  accentBlue: '#A8D8F0',
  skyBlue: '#C5E8F7',

  // Gradientes
  gradientPrimary: 'linear-gradient(135deg, #3B9ED4 0%, #6BBDDF 100%)',
  gradientLight: 'linear-gradient(135deg, #EBF6FC 0%, #FFFFFF 100%)',
  gradientGlass: 'linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(235,246,252,0.85) 100%)',
  gradientHero: 'linear-gradient(180deg, #D6EEF8 0%, #EBF6FC 40%, #FFFFFF 100%)',
  gradientCard: 'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(235,246,252,0.92) 100%)',

  // Backgrounds
  bgPrimary: '#FFFFFF',
  bgSecondary: '#EBF6FC',
  bgTertiary: '#D6EEF8',
  bgGlass: 'rgba(255, 255, 255, 0.88)',

  // Texto
  textPrimary: '#1A2D3A',
  textSecondary: '#3A5568',
  textLight: '#6A8899',
  textWhite: '#FFFFFF',

  // Borders
  borderLight: 'rgba(59, 158, 212, 0.12)',
  borderMedium: 'rgba(59, 158, 212, 0.22)',
  borderGlass: 'rgba(255, 255, 255, 0.6)',

  // Shadows - Frutiger Aero suave
  shadowSoft: '0 4px 20px rgba(59, 158, 212, 0.08)',
  shadowMedium: '0 8px 32px rgba(59, 158, 212, 0.12)',
  shadowStrong: '0 16px 48px rgba(59, 158, 212, 0.16)',
  shadowGlass: '0 8px 32px rgba(59, 158, 212, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.7)',
  shadowCard: '0 10px 40px rgba(59, 158, 212, 0.1)',
  shadowHover: '0 20px 60px rgba(59, 158, 212, 0.18)',

  // Glassmorphism claro
  glassBackground: 'rgba(255, 255, 255, 0.80)',
  glassBackdrop: 'blur(24px)',
  glassBorder: '1px solid rgba(255, 255, 255, 0.65)',

  // Breakpoints
  mobile: '576px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1280px',

  // Border Radius - Smooth curves
  radiusSmall: '12px',
  radiusMedium: '16px',
  radiusLarge: '24px',
  radiusXL: '32px',
  radiusFull: '9999px',

  // Transitions - Smooth and fluid
  transitionFast: '0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  transitionMedium: '0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  transitionSlow: '0.5s cubic-bezier(0.4, 0, 0.2, 1)',

  // Spacing
  spacingXS: '0.5rem',
  spacingSM: '1rem',
  spacingMD: '1.5rem',
  spacingLG: '2rem',
  spacingXL: '3rem',
  spacing2XL: '4rem',
  spacing3XL: '6rem',
};
